import { StyleSheet } from 'react-native';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  text: {
    fontWeight: 400,
  },
  textDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  titleText: {
    fontSize: 14,
    textAlign: 'center',
  },
  priceText: {
    marginTop: 2,
    fontSize: 14,
  },
  subtitleText: {
    marginTop: 4,
    fontSize: 12,
    textAlign: 'center',
  },
  textActive: {
    fontWeight: 700,
  },
  button: {
    borderWidth: 2,
    borderColor: 'transparent',
    padding: 6,
    borderRadius: 16,
  },
  buttonInner: {
    alignItems: 'center',
    gap: 8,
  },
  buttonActive: {
    borderColor: brand.main.water,
    backgroundColor: brand.main.variations['lighterWater-3'],
  },
  buttonFocus: {
    borderColor: FOCUS_COLOR,
  },
  image: {
    height: 125,
    width: '100%',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: 'transparent',
  },
  imagePlaceholder: {
    borderColor: neutrals.neutralGrays.dust,
  },
  imageDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  descriptionContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: 0,
  },
});
